import { Component, OnInit } from '@angular/core';
import { SurveyService } from '../services/surveyService';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  surveyType: any;

  constructor(
    private surveyService: SurveyService
  ) { }

  ngOnInit() {
    this.surveyType = localStorage.getItem('surveyType');

    // if (storedSurveyType) {
    //   this.surveyType = storedSurveyType;
    // } else {
    //   const surveyId = localStorage.getItem('surveyId') || '';
    //   this.surveyService.getSurvey(surveyId).subscribe((res: any) => {
    //     this.surveyType = res?.surveyId;
    //   }, error => {
    //     console.error('Failed to load survey:', error);
    //   });
    // }
  }
}
